module.exports = __webpack_public_path__ + "static/media/dashboard-one-on-one-star-inactive-icon.40a6941b.svg";